"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _axios = _interopRequireDefault(require("axios"));

var _bluebird = _interopRequireDefault(require("bluebird"));

var _browserOrNode = require("browser-or-node");

var _lodash = _interopRequireDefault(require("lodash"));

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

var _utils = require("./lib/utils");

var _settings = _interopRequireDefault(require("./settings"));

var _basic = _interopRequireDefault(require("./_basic"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultCookiePollingInterval = 500; // 0.5 second

var defaultExpireInShort = 3600000; // 1 hour

var defaultExpireInLong = 30758400000; // 1 year

var AuthApi =
/*#__PURE__*/
function (_BasicApi) {
  (0, _inherits2.default)(AuthApi, _BasicApi);

  /**
   * @constructor
   */
  function AuthApi(_ref) {
    var _this;

    var logout = _ref.logout,
        cookieDomain = _ref.cookieDomain,
        authUrl = _ref.authUrl,
        allowGuestLogin = _ref.allowGuestLogin,
        userCookieName = _ref.userCookieName,
        userExpireCookieName = _ref.userExpireCookieName,
        cookiePrefix = _ref.cookiePrefix,
        multiUserCookieName = _ref.multiUserCookieName,
        cookiePollingInterval = _ref.cookiePollingInterval,
        expireInShort = _ref.expireInShort,
        expireInLong = _ref.expireInLong,
        sdkApiUrl = _ref.sdkApiUrl,
        allowIframe = _ref.allowIframe;
    (0, _classCallCheck2.default)(this, AuthApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AuthApi).call(this, {
      userTokenFactory: function userTokenFactory() {}
    })); //eslint-disable-line

    _this.cookie = new _universalCookie.default();
    _this.logout = logout;
    _this.cookieDomain = cookieDomain;
    _this.authUrl = authUrl;
    _this.allowGuestLogin = Boolean(allowGuestLogin);
    _this.sdkApiUrl = sdkApiUrl;
    _this.allowIframe = allowIframe;

    if (!cookiePrefix) {
      cookiePrefix = "".concat(userCookieName, "_new");
    } // should be used for feature migration only. Should be deleted after all feature migrations happened!


    _this.deprecatedCookieName = userCookieName || 'user';
    _this.deprecatedUserExpireCookieName = userExpireCookieName || 'user_expire';
    _this.deprecatedDomain = {
      domain: '.onereach.ai'
    };
    _this.userCookieName = cookiePrefix;
    _this.multiUserCookieName = multiUserCookieName;
    _this.userExpireCookieName = "".concat(cookiePrefix, "_expire");
    _this.cookiePollingInterval = cookiePollingInterval || defaultCookiePollingInterval;
    _this.expireInShort = +expireInShort || defaultExpireInShort;
    _this.expireInLong = +expireInLong || defaultExpireInLong;
    _this.monitorCookieTimeout = null;
    _this.loggedIn = false;
    return _this;
  }

  (0, _createClass2.default)(AuthApi, [{
    key: "monitorCookie",
    value: function monitorCookie(logoutCallback, loginCallback) {
      var _this2 = this;

      // just in case monitorCookie called multiple times in a row
      // we only need one running constantly
      this.stopCookieMonitor();
      this.monitorCookieTimeout = setTimeout(function () {
        //eslint-disable-line no-undef
        var user = _this2._getUser();

        if (user) {
          if (!_this2.loggedIn) {
            _this2.loggedIn = true;
          }

          if (_lodash.default.isFunction(loginCallback)) {
            loginCallback(user);
          }
        } else if (_this2.loggedIn) {
          _this2.loggedIn = false;

          if (_lodash.default.isFunction(logoutCallback)) {
            logoutCallback();
          }
        }

        _this2.monitorCookie(logoutCallback, loginCallback);
      }, this.cookiePollingInterval);
    }
  }, {
    key: "updateCookieExpiration",
    value: function updateCookieExpiration() {
      var user = this._getUser();

      var expire = this.getUserExpire();

      if (user) {
        this._saveCookies(user, expire);
      }

      var multiUser = this.cookie.get(this.multiUserCookieName);

      if (multiUser) {
        this.saveMultiUser(multiUser, expire);
      }
    }
  }, {
    key: "signIn",
    value: function () {
      var _signIn = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref2) {
        var _this3 = this;

        var credentials, long, _ref2$allowGuestLogin, allowGuestLogin, captchaToken, isCaptchaV2Checkbox, verificationCode, userToken, rememberTwoFactor, fingerPrint, options, headers;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                credentials = _ref2.credentials, long = _ref2.long, _ref2$allowGuestLogin = _ref2.allowGuestLogin, allowGuestLogin = _ref2$allowGuestLogin === void 0 ? false : _ref2$allowGuestLogin, captchaToken = _ref2.captchaToken, isCaptchaV2Checkbox = _ref2.isCaptchaV2Checkbox, verificationCode = _ref2.verificationCode, userToken = _ref2.userToken, rememberTwoFactor = _ref2.rememberTwoFactor;
                _context2.next = 3;
                return (0, _utils.generateFingerPrint)();

              case 3:
                fingerPrint = _context2.sent;
                options = _objectSpread({}, credentials, {
                  captchaToken: captchaToken,
                  isCaptchaV2Checkbox: isCaptchaV2Checkbox,
                  verificationCode: verificationCode,
                  fingerPrint: fingerPrint,
                  rememberTwoFactor: rememberTwoFactor
                });

                if (!userToken) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 8;
                return this.getHeaders(userToken);

              case 8:
                headers = _context2.sent;
                options.userToken = _lodash.default.get(headers, 'headers.Authorization', '');

              case 10:
                return _context2.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post(_this3.authUrl, options);
                }).then(function (response) {
                  return response.data;
                }).tap(function (user) {
                  return _this3._validateGuest(user.role, allowGuestLogin);
                }) // TODO add {secure : true}
                .tap(
                /*#__PURE__*/
                function () {
                  var _ref3 = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  _regenerator.default.mark(function _callee(user) {
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(user.twoFactorCheck || user.captchaCheck)) {
                              _context.next = 2;
                              break;
                            }

                            return _context.abrupt("return");

                          case 2:
                            if (!(user.tokenType === 'multi-user')) {
                              _context.next = 5;
                              break;
                            }

                            _this3.saveMultiUser(user, long ? _this3.expireInLong : _this3.expireInShort);

                            return _context.abrupt("return");

                          case 5:
                            _this3.saveUser({
                              long: long,
                              user: user
                            });

                          case 6:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function signIn(_x) {
        return _signIn.apply(this, arguments);
      }

      return signIn;
    }()
  }, {
    key: "saveUser",
    value: function () {
      var _saveUser = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(_ref4) {
        var long, user, key, settingsApi, cookiExpirationDuration;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                long = _ref4.long, user = _ref4.user;
                key = long ? 'cookieExpirationLong' : 'cookieExpirationShort';
                settingsApi = new _settings.default({
                  userTokenFactory: function userTokenFactory() {
                    return user.token;
                  },
                  sdkApiUrl: this.sdkApiUrl
                });
                _context3.prev = 3;
                _context3.next = 6;
                return settingsApi.getMergedSettings({
                  key: key
                });

              case 6:
                cookiExpirationDuration = _context3.sent;
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](3);
                console.log('Unable to fetch settingCookiesExpire from user Settings: ', _context3.t0); //eslint-disable-line no-undef

              case 12:
                if (!cookiExpirationDuration) {
                  cookiExpirationDuration = long ? this.expireInLong : this.expireInShort;
                }

                this._saveCookies(user, cookiExpirationDuration);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 9]]);
      }));

      function saveUser(_x3) {
        return _saveUser.apply(this, arguments);
      }

      return saveUser;
    }()
  }, {
    key: "saveMultiUser",
    value: function saveMultiUser(user, expiration) {
      this.cookie.set(this.multiUserCookieName, user, _lodash.default.assign({
        path: '/',
        expires: this._getNextExpiration(expiration),
        secure: true
      }, this.domain));
    }
  }, {
    key: "signInWithToken",
    value: function signInWithToken(token) {
      var _this4 = this;

      var allowGuestLogin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var shouldNotSaveCookies = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var userInfo = {};

      if (_lodash.default.isObject(token)) {
        // {token, allowGuestLogin = false, shouldNotSaveCookies = false} = token;
        allowGuestLogin = _lodash.default.get(token, 'allowGuestLogin', false);
        shouldNotSaveCookies = _lodash.default.get(token, 'shouldNotSaveCookies', false);
        userInfo = _lodash.default.get(token, 'userInfo', {});
        token = token.token;
      }

      if (!token) {
        return _bluebird.default.reject(new Error('No token given'));
      }

      this._checkDeprecatedCookies();

      return this._validateToken(token, allowGuestLogin).then(function (user) {
        return _lodash.default.assign(user, {
          token: token
        });
      }).tap(function (user) {
        var allow = _lodash.default.get(user, 'allow', false);

        if (!allow) {
          throw Error('Invalid Token');
        }
      }).tap(function (user) {
        if (shouldNotSaveCookies) {
          return;
        }

        _this4._saveCookies(_objectSpread({}, userInfo, {}, user), _this4.getUserExpire());
      });
    }
  }, {
    key: "signOut",
    value: function () {
      var _signOut = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(token) {
        var promises, headers;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                promises = [];

                if (!token) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 5;
                return this.getHeaders(token);

              case 5:
                headers = _context4.sent;
                promises.push(_axios.default.delete("".concat(this.sdkApiUrl, "/auth/fingerprint-token"), headers));

              case 7:
                if (this.multiUserHeaders.headers.authorization) {
                  promises.push(_axios.default.delete("".concat(this.sdkApiUrl, "/multi-user/fingerprint-token"), this.multiUserHeaders));
                }

                _context4.next = 10;
                return _bluebird.default.all(promises);

              case 10:
                _context4.next = 15;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](0);
                console.log('Logout failed: ', _context4.t0); //eslint-disable-line no-undef

              case 15:
                this.removeCookies();

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 12]]);
      }));

      function signOut(_x4) {
        return _signOut.apply(this, arguments);
      }

      return signOut;
    }()
  }, {
    key: "removeCookies",
    value: function removeCookies() {
      this.cookie.remove(this.userExpireCookieName, _lodash.default.assign({
        path: '/'
      }, this.domain));
      this.cookie.remove(this.userCookieName, _lodash.default.assign({
        path: '/'
      }, this.domain));
      this.cookie.remove(this.multiUserCookieName, _lodash.default.assign({
        path: '/'
      }, this.domain)); // should be removed after feature migration only.

      this.cookie.remove(this.deprecatedCookieName, _lodash.default.assign({
        path: '/'
      }, this.domain));
      this.cookie.remove(this.deprecatedUserExpireCookieName, _lodash.default.assign({
        path: '/'
      }, this.domain));
      this.cookie.remove(this.deprecatedCookieName, _lodash.default.assign({
        path: '/'
      }, this.deprecatedDomain));
      this.cookie.remove(this.deprecatedUserExpireCookieName, _lodash.default.assign({
        path: '/'
      }, this.deprecatedDomain));
    }
  }, {
    key: "stopCookieMonitor",
    value: function stopCookieMonitor() {
      if (window) {
        //eslint-disable-line no-undef
        window.clearTimeout(this.monitorCookieTimeout); //eslint-disable-line no-undef
      }
    }
  }, {
    key: "validateUser",
    value: function validateUser() {
      var allowGuestLogin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this._checkDeprecatedCookies();

      var userParams = this._getUser();

      if (!userParams) {
        return _bluebird.default.reject(new Error('No cached user params is available'));
      }

      return this._validateToken(userParams.token, allowGuestLogin).then(function (user) {
        if (!user.identityProvider && userParams.identityProvider) {
          user.identityProvider = userParams.identityProvider;
        }

        return _lodash.default.assign(user, {
          token: userParams.token
        });
      }).tap(function (user) {
        var allow = _lodash.default.get(user, 'allow', false);

        if (!allow) {
          throw Error('Invalid Token');
        }
      });
    }
  }, {
    key: "hasUserParams",
    value: function hasUserParams() {
      return Boolean(this._getUser());
    }
  }, {
    key: "_getNextExpiration",
    value: function _getNextExpiration(expireIn) {
      //eslint-disable-line
      return new Date(Date.now() + expireIn); //eslint-disable-line no-undef
    }
  }, {
    key: "_getUser",
    value: function _getUser() {
      return this.cookie.get(this.userCookieName) || null;
    }
  }, {
    key: "getUserExpire",
    value: function getUserExpire(cookieName) {
      var expireCookie = this.cookie.get(cookieName || this.userExpireCookieName);
      return expireCookie ? parseInt(expireCookie, 10) : this.expireInShort;
    }
  }, {
    key: "_saveCookies",
    value: function _saveCookies(user, expireIn) {
      var nextExpiration = this._getNextExpiration(expireIn);

      this.cookie.set(this.userCookieName, user, _lodash.default.assign({
        path: '/',
        expires: nextExpiration,
        secure: true,
        sameSite: this.allowIframe ? 'none' : 'lax'
      }, this.domain));
      this.cookie.set(this.userExpireCookieName, expireIn, _lodash.default.assign({
        path: '/',
        expires: nextExpiration,
        secure: true,
        sameSite: this.allowIframe ? 'none' : 'lax'
      }, this.domain)); // Should be deleted after migration

      this.cookie.set(this.deprecatedCookieName, user, _lodash.default.assign({
        path: '/',
        expires: nextExpiration
      }, this.domain));
      this.cookie.set(this.deprecatedUserExpireCookieName, expireIn, _lodash.default.assign({
        path: '/',
        expires: nextExpiration
      }, this.domain));
    }
  }, {
    key: "_checkDeprecatedCookies",
    value: function _checkDeprecatedCookies() {
      var user = this.cookie.get(this.deprecatedCookieName);

      if (user) {
        var deprecatedUserExpireValue = this.getUserExpire(this.deprecatedUserExpireCookieName);

        var nextExpiration = this._getNextExpiration(deprecatedUserExpireValue);

        this.cookie.set(this.userCookieName, user, _lodash.default.assign({
          path: '/',
          expires: nextExpiration
        }, this.domain));
        this.cookie.set(this.userExpireCookieName, deprecatedUserExpireValue, _lodash.default.assign({
          path: '/',
          expires: nextExpiration
        }, this.domain));
      }
    }
  }, {
    key: "_validateGuest",
    value: function _validateGuest(role) {
      var allowGuestLoginOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!(this.allowGuestLogin || allowGuestLoginOverride) && _lodash.default.toLower(role) === 'guest') {
        var NoRightsError =
        /*#__PURE__*/
        function (_Error) {
          (0, _inherits2.default)(NoRightsError, _Error);

          function NoRightsError(message) {
            var _this5;

            (0, _classCallCheck2.default)(this, NoRightsError);
            _this5 = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(NoRightsError).call(this));
            _this5.message = message;
            _this5.errorType = 'NoRightsError';
            return _this5;
          }

          return NoRightsError;
        }((0, _wrapNativeSuper2.default)(Error));

        throw new NoRightsError('Authorization for guests is not allowed');
      }
    }
  }, {
    key: "_validateToken",
    value: function _validateToken(token) {
      var _this6 = this;

      var allowGuestLogin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _bluebird.default.try(function () {
        return _this6.getHeaders(token);
      }).then(function (headers) {
        return _axios.default.get(_this6.authUrl, headers);
      }).then(function (response) {
        return response.data;
      }).tap(function (user) {
        return _this6._validateGuest(user.role, allowGuestLogin);
      });
    }
  }, {
    key: "multiUserGetUsersList",
    value: function () {
      var _multiUserGetUsersList = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5() {
        var _ref5, data;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.multiUserHeaders.headers.authorization) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", false);

              case 2:
                _context5.next = 4;
                return _axios.default.get("".concat(this.sdkApiUrl, "/multi-user/list-users"), this.multiUserHeaders);

              case 4:
                _ref5 = _context5.sent;
                data = _ref5.data;
                return _context5.abrupt("return", data);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function multiUserGetUsersList() {
        return _multiUserGetUsersList.apply(this, arguments);
      }

      return multiUserGetUsersList;
    }()
  }, {
    key: "multiUserLoginUser",
    value: function () {
      var _multiUserLoginUser = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(_ref6) {
        var accountId, id, long, _ref7, data;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                accountId = _ref6.accountId, id = _ref6.id, long = _ref6.long;
                _context6.next = 3;
                return _axios.default.post("".concat(this.sdkApiUrl, "/multi-user/user-token"), {
                  accountId: accountId,
                  id: id
                }, this.multiUserHeaders);

              case 3:
                _ref7 = _context6.sent;
                data = _ref7.data;
                _context6.next = 7;
                return this.saveUser({
                  long: long,
                  user: data
                });

              case 7:
                return _context6.abrupt("return", data);

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function multiUserLoginUser(_x5) {
        return _multiUserLoginUser.apply(this, arguments);
      }

      return multiUserLoginUser;
    }()
  }, {
    key: "getUserNameForLockScreen",
    value: function () {
      var _getUserNameForLockScreen = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(user) {
        var multiUserCookie, multiUserId, username, token, _ref8, data;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                multiUserCookie = this.cookie.get(this.multiUserCookieName) || {};

                if (!multiUserCookie.username) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt("return", multiUserCookie.username);

              case 3:
                multiUserId = user.multiUserId, username = user.username, token = user.token;

                if (!multiUserId) {
                  _context7.next = 15;
                  break;
                }

                _context7.t0 = _axios.default;
                _context7.t1 = "".concat(this.sdkApiUrl, "/user/multi-user");
                _context7.next = 9;
                return this.getHeaders(token);

              case 9:
                _context7.t2 = _context7.sent;
                _context7.next = 12;
                return _context7.t0.get.call(_context7.t0, _context7.t1, _context7.t2);

              case 12:
                _ref8 = _context7.sent;
                data = _ref8.data;
                return _context7.abrupt("return", data.username);

              case 15:
                return _context7.abrupt("return", username);

              case 16:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getUserNameForLockScreen(_x6) {
        return _getUserNameForLockScreen.apply(this, arguments);
      }

      return getUserNameForLockScreen;
    }()
  }, {
    key: "multiUserGetProfile",
    value: function () {
      var _multiUserGetProfile = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8() {
        var _ref9, data;

        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _axios.default.get("".concat(this.sdkApiUrl, "/multi-user/profile"), this.multiUserHeaders);

              case 2:
                _ref9 = _context8.sent;
                data = _ref9.data;
                return _context8.abrupt("return", data);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function multiUserGetProfile() {
        return _multiUserGetProfile.apply(this, arguments);
      }

      return multiUserGetProfile;
    }()
  }, {
    key: "multiUserSetProfile",
    value: function () {
      var _multiUserSetProfile = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(profile) {
        var _ref10, data;

        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _axios.default.post("".concat(this.sdkApiUrl, "/multi-user/profile"), profile, this.multiUserHeaders);

              case 2:
                _ref10 = _context9.sent;
                data = _ref10.data;
                return _context9.abrupt("return", data);

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function multiUserSetProfile(_x7) {
        return _multiUserSetProfile.apply(this, arguments);
      }

      return multiUserSetProfile;
    }()
  }, {
    key: "validateMultiUserToken",
    value: function () {
      var _validateMultiUserToken = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10() {
        var _ref11, data;

        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _axios.default.get("".concat(this.sdkApiUrl, "/multi-user/token"), this.multiUserHeaders);

              case 2:
                _ref11 = _context10.sent;
                data = _ref11.data;
                return _context10.abrupt("return", data);

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function validateMultiUserToken() {
        return _validateMultiUserToken.apply(this, arguments);
      }

      return validateMultiUserToken;
    }()
  }, {
    key: "multiUserUploadIcon",
    value: function () {
      var _multiUserUploadIcon = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(_ref12) {
        var name, contentType, _ref12$cacheControl, cacheControl, file, _ref13, data, FormDataLib, formData;

        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                name = _ref12.name, contentType = _ref12.contentType, _ref12$cacheControl = _ref12.cacheControl, cacheControl = _ref12$cacheControl === void 0 ? 'no-cache' : _ref12$cacheControl, file = _ref12.file;
                _context11.next = 3;
                return _axios.default.post("".concat(this.sdkApiUrl, "/multi-user/sign-upload-url"), {
                  name: name,
                  contentType: contentType,
                  cacheControl: cacheControl
                }, this.multiUserHeaders);

              case 3:
                _ref13 = _context11.sent;
                data = _ref13.data;
                FormDataLib = _browserOrNode.isNode ? require('form-data') : FormData; // eslint-disable-line no-undef

                formData = new FormDataLib();

                _lodash.default.forEach(data.uploadParams.fields, function (value, key) {
                  formData.append(key, value);
                });

                formData.append('cache-control', cacheControl);
                formData.append('content-type', contentType);
                formData.append('File', file, name);

                if (!_browserOrNode.isNode) {
                  _context11.next = 13;
                  break;
                }

                return _context11.abrupt("return", new _bluebird.default(function (resolve, reject) {
                  formData.submit(data.uploadParams.url, function (error) {
                    if (error) return reject(error);
                    resolve();
                  });
                }));

              case 13:
                _context11.next = 15;
                return _axios.default.post(data.uploadParams.url, formData);

              case 15:
                return _context11.abrupt("return", data.downloadUrl);

              case 16:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function multiUserUploadIcon(_x8) {
        return _multiUserUploadIcon.apply(this, arguments);
      }

      return multiUserUploadIcon;
    }()
  }, {
    key: "confirmEmailChange",
    value: function () {
      var _confirmEmailChange = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(_ref14) {
        var token, _ref15, data;

        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                token = _ref14.token;
                _context12.next = 3;
                return _axios.default.post("".concat(this.sdkApiUrl, "/multi-user/change-email-finish"), {
                  token: token
                });

              case 3:
                _ref15 = _context12.sent;
                data = _ref15.data;
                return _context12.abrupt("return", data);

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function confirmEmailChange(_x9) {
        return _confirmEmailChange.apply(this, arguments);
      }

      return confirmEmailChange;
    }()
  }, {
    key: "multiUserUpdateTwoFactor",
    value: function () {
      var _multiUserUpdateTwoFactor = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(_ref16) {
        var _this7 = this;

        var secret, enabled, codes, verificationCode;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                secret = _ref16.secret, enabled = _ref16.enabled, codes = _ref16.codes, verificationCode = _ref16.verificationCode;
                return _context13.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.put("".concat(_this7.sdkApiUrl, "/multi-user/twofactor"), {
                    secret: secret,
                    enabled: enabled,
                    codes: codes,
                    verificationCode: verificationCode
                  }, _this7.multiUserHeaders).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function multiUserUpdateTwoFactor(_x10) {
        return _multiUserUpdateTwoFactor.apply(this, arguments);
      }

      return multiUserUpdateTwoFactor;
    }()
  }, {
    key: "domain",
    get: function get() {
      return this.cookieDomain ? {
        domain: this.cookieDomain
      } : {};
    }
  }, {
    key: "multiUserHeaders",
    get: function get() {
      var _ref17 = this.cookie.get(this.multiUserCookieName) || {},
          _ref17$token = _ref17.token,
          token = _ref17$token === void 0 ? '' : _ref17$token;

      return {
        headers: {
          authorization: token
        }
      };
    }
  }]);
  return AuthApi;
}(_basic.default);

var _default = AuthApi;
exports.default = _default;